import React from 'react'
import { Outlet } from 'react-router-dom'

const LayoutInPatient = () => {
    return (
        <div>
            {/* <Header /> */}
            <Outlet />
        </div>
    )
}

export default LayoutInPatient
